(function () {
	'use strict';
	$(document).ready(function () {
		const $header = $('header');
		const $menuOverlay = $('.menu-overlay');
		const $menuInline = $('.menu-inline');
		// const isMobileMedia = window.matchMedia("(max-width: 767px)")

		// Menu toggle
		$('.menu-toggle').on('click', function () {
			$menuOverlay.fadeToggle(300);
			$menuInline.fadeToggle(300);
			$menuOverlay.toggleClass('open');
			$menuInline.toggleClass('open');
			$(this).toggleClass('open');
			$header.toggleClass('open');
			const isOpen = $menuOverlay.hasClass('open') || $menuInline.hasClass('open');
			document.body.classList.toggle('menu-open', isOpen);
		});

		// Language switcher dropdown
		const $languageSwitcher = $('.language-switcher');
		const $dropdownToggle = $languageSwitcher.find('.language-button');
		const $dropdownMenu = $languageSwitcher.find('.language-list');

		$dropdownToggle.on('click', function (e) {
			e.preventDefault();
			const isExpanded = $(this).attr('aria-expanded') === 'true';

			$(this).attr('aria-expanded', !isExpanded);
			$dropdownMenu.toggleClass('visible');
			$languageSwitcher.toggleClass('open');
		});

		clickedOutside('.language-switcher', () => {
			$dropdownToggle.attr('aria-expanded', 'false');
			$dropdownMenu.removeClass('visible');
			$languageSwitcher.removeClass('open');
		});


		$('ul.header-main-menu li.menu-item-has-children > .menu-item-trigger').on('click', function (e) {
			e.preventDefault();
			const $this = $(this);
			const $li = $(this).parent();
			const $siblingList = $(this).siblings('.submenu-wrapper');
			const submenuLevel = $this.data('depth');

			//if (`${submenuLevel}` === '2' && !isMobileMedia.matches) return;

			if ($this.hasClass('active')) {
				$siblingList.stop().slideUp(300);
				$li.removeClass('open');
				$this.removeClass('active');
				$this.attr('aria-expanded', 'false');
			} else {
				closeSubmenus(submenuLevel);
				$siblingList.stop().slideToggle(300);
				$li.toggleClass('open');
				$this.toggleClass('active');
				$this.attr(
					'aria-expanded',
					$this.attr('aria-expanded') === 'true' ? 'false' : 'true',
				);
			}
		});

		clickedOutside('.submenu-wrapper', () => {
			closeSubmenus();
			$menuInline.find('.menu-item-trigger').attr('aria-expanded', 'false');
			$menuInline.find('.submenu-wrapper').slideUp(300);
		}, '.menu-item-trigger');

		function closeSubmenus(dataLevel = 1) {
			$(`ul[data-level="${dataLevel}"] li.menu-item-has-children > .menu-item-trigger.active`).each(function () {
				$(this).siblings('.submenu-wrapper').stop().slideToggle(300, function () {
					$(this).css('display', '');
				});
				$(this).removeClass('active');
				$(this).attr('aria-expanded', 'false');
				$(this).parent().removeClass('open');
			});
		}

	});
}(jQuery));
